import { Timestamp } from "firebase/firestore";
import { Review } from "../interfaces/entities/review";

export const DefaultReview = (reviewerId: string, companyId: string, branchId: string, userId: string): Review => ({
    id: '',
    editCount: 0,
    companyId,
    branchId,
    userId,
    reviewerId,
    rating: 0,
    comment: '',

    createdAt: Timestamp.fromDate(new Date()),
    updatedAt: Timestamp.fromDate(new Date()),
    
    reviewerPhone: '',
})